export default "__VITE_ASSET__DNFX9iP1__"